import { Box, ButtonBase, Paper } from '@mui/material';
import React from 'react';
import RestaurantHeaderSkeleton from './RestaurantHeaderSkeleton';
import RestaurantImageSkeleton from './RestaurantImageSkeleton';

interface RestaurantItemSkeletonProps {
}

const RestaurantItemSkeleton: React.FC<RestaurantItemSkeletonProps> = ({ }) => {
    return (
        <ButtonBase
            sx={(theme) => ({
                width: "100%",
                [theme.breakpoints.up("sm")]: {
                    // maxWidth: 372
                },
                "&:hover": {
                    boxShadow: (theme) => theme.shadows[1]
                },
            })}>
            <Paper sx={{ width: "100%", p: 0 }}>
                <RestaurantImageSkeleton />
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    alignItems={"center"}
                    p={1}
                    pl={1.5}>
                    <RestaurantHeaderSkeleton />
                </Box>
            </Paper>
        </ButtonBase>
    )
}

export default RestaurantItemSkeleton;